/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */

/**
 * Optional calculation mode override. When omitted, the entity default is used and falls back to `b2b_standard`.
 * @nullable
 */
export type CustomCreateCreditNoteCalculationMode = typeof CustomCreateCreditNoteCalculationMode[keyof typeof CustomCreateCreditNoteCalculationMode] | null;


export const CustomCreateCreditNoteCalculationMode = {
  b2b_standard: 'b2b_standard',
  b2c_gross_discount: 'b2c_gross_discount',
} as const;
